import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true, // Enable dark mode
    themes: {
      light: {},
      dark: {
        primary: "#FFF", // Change this color to your desired primary color
        darkenText: "#BDBDBD",
        secondary: "#C64925",
        background: "#2A2A2A",
        backgroundDarkn: "#232122",
      },
      options: {
        customProperties: true,
        disable: {
          ripple: true, // This disables the ripple effect globally
        },
      },
    },
  },

  rtl: true,
});
